const buildQueryFields = (sanitizedEntityFields, entityTypes, isFull) => `results {
    ${entityTypes.map(entityType => `
    ... on ${entityType} {
      ${sanitizedEntityFields}
      __typename
      id
     ${isFull ? 'pageBuilderComponents: preparedPageBuilderComponents' : ''}
    }`)}
  },
  total
  `;
export default buildQueryFields;
//# sourceMappingURL=build-query-fields.js.map